import { create } from 'zustand'

export type Theme = 'dark' | 'light'

const STORAGE_KEY = 'saasfarm-theme'

// ─── Synchronous initialization ───────────────────────────────────────────────
// Runs before React renders so there's no flash of the wrong theme.

function readStoredTheme(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'light' || stored === 'dark') return stored
  } catch {
    // localStorage unavailable (e.g. SSR-like environments)
  }
  return 'dark'
}

const initialTheme = readStoredTheme()
document.documentElement.setAttribute('data-theme', initialTheme)

// ─── Store ────────────────────────────────────────────────────────────────────

interface ThemeStore {
  theme: Theme
  toggleTheme: () => void
}

export const useThemeStore = create<ThemeStore>()((set, get) => ({
  theme: initialTheme,

  toggleTheme: () => {
    const next: Theme = get().theme === 'dark' ? 'light' : 'dark'
    document.documentElement.setAttribute('data-theme', next)
    try { localStorage.setItem(STORAGE_KEY, next) } catch { /* ignore */ }
    set({ theme: next })
  },
}))
